export const INITIAL_PROFILE_REQUEST = "INITIAL_PROFILE_REQUEST";
export const FINAL_PROFILE_REQUEST = "FINAL_PROFILE_REQUEST";
export const FETCH_PROFILE_SUCCESS = "FETCH_PROFILE_SUCCESS";
